export enum JobCardActionEnum {
  MORE_INFO = 'more_info',
  ACCEPT = 'accept',
  CANCEL = 'cancel',
  PROFILE_VIEW = 'profile-view',
  VIEW_TEASER = 'view-teaser',
  WITHDRAW = 'withdraw',
  REJECT = 'reject',
  APPLY = 'apply'
}

export enum JobCardStatusEnum {
  ACCEPTED = 2,
  REJECTED = 4,
  PENDING = 1
}
